
import {eventBus} from "@/services/event-bus";
import ActivityService from "@/services/activity.service";
import Vue from "vue";
import Activity from "@/models/activity";

export default Vue.extend({
  name: "EditActivityForm",
  methods: {
    showForm() {
      this.isVisible = true;
    },
    hideForm() {
      this.isVisible = false;
    },
    clearForm() {
      this.activity = new Activity({});
      this.isFormValid = true;
    },
    refreshForm: function () {
      // eslint-disable-next-line no-console
      console.log("refresh");
      if (this.activity.id != null) {
        this.loadActivity(this.activity.id);
      }
    },
    cancelForm: function () {
      // eslint-disable-next-line no-console
      console.log("cancel");
      this.hideForm();
    },
    validateForm() {
      // eslint-disable-next-line no-console
      console.log("validate");
      if (this.form.validate()) {
        this.isFormValid = true;
        return
      }
      this.isFormValid = false
    },
    submitForm: function () {
      // eslint-disable-next-line no-console
      console.log("submit");
      this.validateForm();
      if (this.isFormValid) {
        this.writeActivity();
        eventBus.$emit('refresh-activity-list');
        this.hideForm();
      }
    },
    loadActivity(activityId: number) {
      // eslint-disable-next-line no-console
      console.log("activityId:" + activityId);
      if (!activityId) return false
      return ActivityService.activityById(activityId).then(d => this.activity = d).catch(reason => eventBus.$emit('error', reason));
    },
    writeActivity() {
      if (!this.activity.id) {
        // eslint-disable-next-line no-console
        console.log("create");
        return ActivityService.createActivity(this.activity)
            .then(() => eventBus.$emit('refresh-activity-list'));
      }
      // eslint-disable-next-line no-console
      console.log("update");
      return ActivityService.updateActivity(this.activity);
    },
  },
  data() {
    return {
      isVisible: false,
      isFormValid: true,
      activity: new Activity(0),
      nameRules: [
        (v: any) => !!v || 'Nazwa zajęcia jest wymagana',
        (v: any) => (v && v.length <= 40) || 'Nazwa zajęcia musi być krótsza niż 40 znaków',
      ],
    }
  },
  mounted() {
    eventBus.$on('edit-activity', (activityId: number) => {
      // eslint-disable-next-line no-console
      console.log("edit-activity:" + activityId);
      this.clearForm();
      this.loadActivity(activityId);
      this.showForm();
    })
    eventBus.$on('create-activity', () => {
      // eslint-disable-next-line no-console
      console.log("create-activity:");
      this.clearForm();
      this.showForm();
    })
    this.activity.code = '#fff';
  },
  computed: {
    form(): Vue & { validate: () => boolean } {
      return this.$refs.form as Vue & { validate: () => boolean }
    }
  } // Use it like so: this.form.validate()
})
